import React from 'react';
import { Header, Grid, Loader, Divider, Segment, Popup, Icon } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer } from 'react-toastify';

import StudentsWithGroup from './StudentsWithGroup';
import StudentsWithoutGroup from './StudentsWithoutGroup';
import { FormattedMessage } from 'react-intl';
import { IconHeader } from '../../Professor/ProfessorInputGrades/css';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class Students extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            groupStudents: [],
            students: [],
            loading: true
        };

        this.getStudents = this.getStudents.bind(this);
    }

    componentDidMount() {
        this.getStudents();
    }

    getStudents() {
        const enCollator = new Intl.Collator('hr');
        let obj = {};
        axios.post(`course/groups/students/${this.props.location.state.courseImplementationGroupId}/${localStorage.getItem('groupType')}/false`, { ...obj })
            .then(res => {
                this.setState({ students: res.data, loading: false });
            })
            .catch(err => {
                console.log('Failed to fetch students');
            });

        axios.post(`course/groups/students/${this.props.location.state.courseImplementationGroupId}/${localStorage.getItem('groupType')}/true`, { ...obj })
            .then(res => {
                this.setState({ groupStudents: res.data });
            })
            .catch(err => {
                console.log('Failed to fetch groupStudents');
            });
    }


    render() {
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;

        if (this.props.location.state.active) {
            return (
                <div>
                    <h1>Raspoređivanje studenata po grupama</h1>
                    <Segment.Group raised>
                        <Segment clearing>
                            <Header as="h3">
                                <Header.Content>
                                    {this.props.location.state.groupName}
                                </Header.Content>
                                <Header style={IconHeader} floated="right" >
                                    <Popup
                                        trigger={<Icon
                                            link
                                            circular
                                            basic="true"
                                            floated="right"
                                            name="arrow left"
                                            onClick={() => window.history.go(-1)}
                                        />}
                                        content={<FormattedMessage id="common.back" />}
                                        hideOnScroll
                                        position="top center"
                                    />
                                </Header>
                                <Header.Subheader>Naziv grupe</Header.Subheader>
                            </Header>
                        </Segment>
                        <Segment>
                            <Grid columns="equal" centered className="stackable">
                                <Grid.Row streched>
                                    <Grid.Column>
                                        <StudentsWithoutGroup
                                            data={this.state.students}
                                            groupStudents={this.state.groupStudents}
                                            getStudents={this.getStudents}
                                            courseImplementationGroupId={this.props.location.state.courseImplementationGroupId}
                                            examGroup={window.location.pathname === '/ispitne-grupe/studenti' || window.location.pathname === '/ispitni-rokovi/ispiti/grupe/studenti'}
                                            edit={localStorage.getItem('academicYearId') === localStorage.getItem('currentAcademicYearId')}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <StudentsWithGroup
                                            data={this.state.groupStudents}
                                            getStudents={this.getStudents}
                                            courseImplementationGroupId={this.props.location.state.courseImplementationGroupId}
                                            groupName={this.props.location.state.groupName}
                                            edit={localStorage.getItem('academicYearId') === localStorage.getItem('currentAcademicYearId')}
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Segment>
                    </Segment.Group>

                    <ToastContainer hideProgressBar />

                </div>
            );
        }

        return (
            <div>
                <Header as="h1">Studenti</Header>
                <StudentsWithGroup
                    data={this.state.groupStudents}
                    getStudents={this.getStudents}
                    courseImplementationGroupId={this.props.location.state.courseImplementationGroupId}
                    archived
                />


                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentGroups/Students.js